(function () {
  'use strict';

  // Only the actual horizontal-scroll strip in collection.liquid.
  // .pp-dept-strip uses flex-wrap:wrap (no horizontal scroll).
  var STRIP_SELECTORS = [
    '.pp-cat-strip',
  ];

  function updateButtons(strip, prev, next, wrap) {
    var atStart = strip.scrollLeft <= 2;
    var atEnd   = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd   ? 'true' : 'false');
    if (atEnd) {
      wrap.classList.add('pp-at-end');
    } else {
      wrap.classList.remove('pp-at-end');
    }
  }

  function makeSVG(d) {
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">'
      + '<path d="' + d + '"/></svg>';
  }

  function initStrip(strip) {
    if (strip.dataset.carousel) return;
    strip.dataset.carousel = '1';

    /* Add scroll-snap to strip and its direct children */
    strip.style.scrollSnapType = 'x mandatory';
    Array.from(strip.children).forEach(function (child) {
      child.style.scrollSnapAlign = 'start';
    });

    /* Wrap in position:relative container */
    var wrap = document.createElement('div');
    wrap.className = 'pp-carousel-wrap';
    strip.parentNode.insertBefore(wrap, strip);
    wrap.appendChild(strip);

    /* Prev / Next buttons */
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pp-carousel-btn pp-carousel-btn--prev';
    prev.setAttribute('aria-label', 'Scroll left');
    prev.setAttribute('aria-disabled', 'true');
    prev.innerHTML = makeSVG('M15 18l-6-6 6-6');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'pp-carousel-btn pp-carousel-btn--next';
    next.setAttribute('aria-label', 'Scroll right');
    next.innerHTML = makeSVG('M9 18l6-6-6-6');

    wrap.appendChild(prev);
    wrap.appendChild(next);

    /* Initial state */
    updateButtons(strip, prev, next, wrap);

    /* Scroll listener */
    strip.addEventListener('scroll', function () {
      updateButtons(strip, prev, next, wrap);
    }, { passive: true });

    /* Button clicks — scroll exactly one container width */
    prev.addEventListener('click', function () {
      strip.scrollBy({ left: -strip.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      strip.scrollBy({ left: strip.clientWidth, behavior: 'smooth' });
    });

    /* Keyboard navigation */
    strip.setAttribute('tabindex', '0');
    strip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        strip.scrollBy({ left: -140, behavior: 'smooth' });
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        strip.scrollBy({ left: 140, behavior: 'smooth' });
      }
    });

    /* Re-check on resize */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        updateButtons(strip, prev, next, wrap);
      }).observe(strip);
    }
  }

  function initSidebarEsc() {
    // ESC to close the filter bottom-sheet.
    // open/close/overlay clicks are already wired via onclick attrs in collection.liquid.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var sb = document.getElementById('clSidebar');
        if (sb && sb.classList.contains('open') && typeof window.closeSidebar === 'function') {
          window.closeSidebar();
        }
      }
    });
  }

  function init() {
    STRIP_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(initStrip);
    });
    initSidebarEsc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
